import { supabase } from '../../lib/supabase';

export interface LeadNotificationData {
  name: string;
  email?: string;
  phone?: string;
  message?: string;
  event_type?: string;
  event_date?: string;
  city?: string;
}

export interface LeadNotificationResponse {
  ok: boolean;
  error?: string;
}

/**
 * Envía una notificación por email cuando llega un nuevo lead.
 * No requiere sesión de usuario — usa la anon key directamente.
 * La notificación llega a axloweb2018@gmail.com
 */
export async function sendLeadNotification(
  data: LeadNotificationData,
): Promise<LeadNotificationResponse> {
  try {
    const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
    const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

    if (!supabaseUrl || !supabaseAnonKey) {
      console.warn('⚠️ sendLeadNotification: faltan variables de entorno Supabase');
      return { ok: false, error: 'Configuración incompleta' };
    }

    const url = `${supabaseUrl}/functions/v1/notify_lead`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': supabaseAnonKey,
      },
      body: JSON.stringify(data),
    });

    const responseText = await response.text();
    let result: { ok: boolean; error?: string; code?: string } = { ok: false };

    try {
      result = JSON.parse(responseText);
    } catch {
      // Si no es JSON, usar el texto como error
      return { ok: false, error: responseText || `HTTP ${response.status}` };
    }

    if (!response.ok || !result.ok) {
      const errorMsg = result.error || result.code || `HTTP ${response.status}`;
      console.error('❌ sendLeadNotification error:', errorMsg);
      return { ok: false, error: errorMsg };
    }

    console.log('✅ Notificación de lead enviada correctamente');
    return { ok: true };
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'Error desconocido';
    console.error('❌ sendLeadNotification excepción:', msg);
    return { ok: false, error: msg };
  }
}